export default __webpack_public_path__ + "static/media/mushiesDK.6520585e.jpg";